export const truncateText = (text = '', limit = 50) => {
    if (!text) return '';
    return text.length > limit ? text.slice(0, limit) + '....' : text;
  };

/**
 * Strip markdown syntax so plain text can be shown in table cells
 * without raw ### ** * characters.
 */
export function stripMarkdown(text = '') {
  if (!text) return '';
  return text
    .replace(/^#{1,6}\s+/gm, '')               // remove heading hashes
    .replace(/\*{1,3}([^*\n]+)\*{1,3}/g, '$1') // bold/italic
    .replace(/_{1,2}([^_\n]+)_{1,2}/g, '$1')   // underline/italic
    .replace(/`{1,3}[^`]*`{1,3}/g, '')          // inline code
    .replace(/!\[.*?\]\(.*?\)/g, '')             // images
    .replace(/\[([^\]]+)\]\(.*?\)/g, '$1')      // links → keep label
    .replace(/^[-*+]\s+/gm, '')                 // unordered list bullets
    .replace(/^\d+\.\s+/gm, '')                 // ordered list numbers
    .replace(/^>\s+/gm, '')                     // blockquotes
    .replace(/[-]{3,}/g, '')                    // horizontal rules
    .replace(/\n/g, ' ')                        // flatten newlines
    .replace(/\s{2,}/g, ' ')                    // collapse spaces
    .trim();
}

export function toCamelCase(str) {
    return str
      .replace(/[-_]+/g, ' ')                // replace - and _ with space
      .replace(/[^\w\s]/g, '')               // remove non-word characters
      .trim()                                // remove leading/trailing spaces
      .split(/\s+/)                          // split by one or more spaces
      .map((word, index) => {
        if (index === 0) {
          return word.toLowerCase();         // lowercase first word
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // capitalize others
      })
      .join('');
  }
  

  export function toSentenceCase(str) {
    const trimmed = str.trim();
    if (!trimmed) return '';

    if (trimmed.toLowerCase() === 'inprogress' || trimmed.toLowerCase() === 'in progress') return 'In Progress';
    if (trimmed.toLowerCase() === 'attach atr') return 'Attach ATR';
    if (trimmed.toLowerCase() === 'attach btr') return 'Attach BTR';
    if (trimmed.toLowerCase() === 'add comment' || trimmed.toLowerCase() === 'addcomment') return 'Attach BTR';
  
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }

export function getOfficerGrievanceStatus(row) {
  if (!row) return 'Attach BTR';
  const status = (row.officer_grievance_status || '').trim().toLowerCase();
  const btrStatus = (row.btr_status || '').trim();

  // Resolved — highest priority
  if (status === 'resolved' || row.atr_uploaded) {
    return 'Resolved';
  }

  // BTR rejected by admin — officer needs to revise and resubmit
  if (btrStatus === 'Rejected' || status === 'btr rejected') {
    return 'BTR Rejected';
  }

  // BTR submitted and under admin review
  if (
    btrStatus === 'Under Review' ||
    status === 'btr under review' ||
    status === 'btr submitted'
  ) {
    return 'BTR Under Review';
  }

  // ATR attached / Attach ATR phase (BTR was approved by admin)
  if (status === 'attach atr' || btrStatus === 'Approved') {
    return 'Attach ATR';
  }

  return 'Attach BTR';
}


export function getUserGrievanceStatus(row) {
  if (!row) return 'Open';
  const officerStatus = (row.officer_grievance_status || '').trim().toLowerCase();
  const userStatus = (row.user_grievance_status || '').trim().toLowerCase();

  if (officerStatus === 'resolved' || userStatus === 'resolved' || row.atr_uploaded) {
    return 'Resolved';
  }

  const hasBtr =
    userStatus === 'inprogress' ||
    userStatus === 'in progress' ||
    officerStatus === 'attach atr' ||
    (row.btr_status && row.btr_status !== 'None' && row.btr_status?.toLowerCase() !== 'none') ||
    Boolean(row.btr_file_url) ||
    Boolean(row.btr_content) ||
    Boolean(row.btr_summary) ||
    Boolean(row.btr_submitted);

  if (hasBtr) {
    return 'In Progress';
  }

  return 'Open';
}
  